import { getMatchPeriodConf } from '../configs/matchPeriods';

/**
 * Get match period title.
 *
 * @param {number} periodTypeId
 * @return {string}
 */
export function getMatchPeriodTitle(periodTypeId) {
  const period = getMatchPeriodConf(periodTypeId);

  const lang = 'ru';

  const names = period && period.names;

  return names ? names[lang] : '--';
}
